import fp from 'lodash/fp';
import { LOCATION_CHANGE } from 'react-router-redux';
import { handleActions } from 'redux-actions';
import { routes } from '../../../constants/routes';
import { mapReducersFromConfigurations } from '../../helpers/reducer';
import { configurations } from './configurations';

export const initialState = {
  isAuthenticated: false,
  isLoggingIn: false,
  isLoggingOut: false,
  userId: null,
  idToken: null,
  mockUserId: null,
  message: null,
  lastPath: null
};

const redirectBlacklist = [
  routes.forgotPassword,
  routes.login,
  routes.logout
];

const reducer = handleActions({
  ...mapReducersFromConfigurations('session')(configurations),
  [LOCATION_CHANGE]: (state, { payload: { pathname, search } }) => ({
    ...state,
    isLoggingIn: false,
    message: null,
    lastPath: !fp.contains(pathname + search, redirectBlacklist) ?
      pathname + search :
      state.lastPath
  })
}, initialState);

export default reducer;



// WEBPACK FOOTER //
// ./src/state/modules/session/reducers.js